/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification
 */
export interface FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    checked_at: string;
    /**
     * 
     */
    npi_found: boolean;
    /**
     * 
     */
    is_eligible_for_home_health?: boolean | null;
    /**
     * 
     */
    is_eligible_for_hospice?: boolean | null;
    /**
     * 
     */
    is_eligible_for_part_b?: boolean | null;
    /**
     * 
     */
    is_eligible_for_durable_medical_equipment?: boolean | null;
    /**
     * 
     */
    is_eligible_for_power_mobility_devices?: boolean | null;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification(value: object): value is FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('checked_at' in value) || value['checked_at'] === undefined) return false;
    if (!('npi_found' in value) || value['npi_found'] === undefined) return false;
    return true;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'checked_at': json['checked_at'],
        'npi_found': json['npi_found'],
        'is_eligible_for_home_health': json['is_eligible_for_home_health'] === undefined ? undefined : json['is_eligible_for_home_health'] === null ? null : json['is_eligible_for_home_health'],
        'is_eligible_for_hospice': json['is_eligible_for_hospice'] === undefined ? undefined : json['is_eligible_for_hospice'] === null ? null : json['is_eligible_for_hospice'],
        'is_eligible_for_part_b': json['is_eligible_for_part_b'] === undefined ? undefined : json['is_eligible_for_part_b'] === null ? null : json['is_eligible_for_part_b'],
        'is_eligible_for_durable_medical_equipment': json['is_eligible_for_durable_medical_equipment'] === undefined ? undefined : json['is_eligible_for_durable_medical_equipment'] === null ? null : json['is_eligible_for_durable_medical_equipment'],
        'is_eligible_for_power_mobility_devices': json['is_eligible_for_power_mobility_devices'] === undefined ? undefined : json['is_eligible_for_power_mobility_devices'] === null ? null : json['is_eligible_for_power_mobility_devices'],
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification {
    return FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerificationToJSONTyped(value?: FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerPecosVerification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'checked_at': value['checked_at'],
        'npi_found': value['npi_found'],
        'is_eligible_for_home_health': value['is_eligible_for_home_health'],
        'is_eligible_for_hospice': value['is_eligible_for_hospice'],
        'is_eligible_for_part_b': value['is_eligible_for_part_b'],
        'is_eligible_for_durable_medical_equipment': value['is_eligible_for_durable_medical_equipment'],
        'is_eligible_for_power_mobility_devices': value['is_eligible_for_power_mobility_devices'],
    };
}

